(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockEkomi', {
            bindings: {
                angebot: '<abeAngebot'
            },
            templateUrl: 'bloecke/ekomi/blockEkomi.html',
            controller: BlockEkomiController,
            controllerAs: 'ekomiVm'
        });

    BlockEkomiController.$inject = [
        'lodash',
        'AppConfig',
        'MiscUtilsService',
        'BasisAngebotService'
    ];
    function BlockEkomiController(_, AppConfig, MiscUtilsService, BasisAngebotService) {
        var vm = this;

        vm.$onInit = onInit;

        vm.isVisible = isVisible;

        function onInit() {
            activate();
        }

        function activate() {

            if (_.get(AppConfig.REITER, 'abschluss.blockEkomi') !== false && !MiscUtilsService.isAppModus()) {
                BasisAngebotService.getEKomiLink(vm.angebot).then(function (data) {
                    vm.linkEKomi = data;
                }).catch(function () {
                    vm.linkEKomi = null;
                });
            }
        }

        function isVisible() {
            return !!vm.linkEKomi;
        }
    }
})();
